import { FunctionComponent, KeyboardEvent, useCallback, useRef } from "react";
import * as Styled from "./canvas-panel.style";
import { useUiData } from "src/ui";

export const CanvasPanel: FunctionComponent = () => {
	const { visualization } = useUiData();
	const { onCanvasCreated, deleteSelected, select } = visualization;

	const canvasRef = useRef<HTMLCanvasElement>();

	const onCanvasRef = useCallback(
		(canvas: HTMLCanvasElement | null) => {
			canvasRef.current = canvas ?? undefined;
			if (canvas !== null && onCanvasCreated) {
				onCanvasCreated(canvas);
			}
		},
		[onCanvasCreated],
	);

	const onKeyUp = (ev: KeyboardEvent) => {
		const deleteKeys = ["Backspace", "Delete"];
		const escapeKeys = ["Escape", "Esc"];

		if (deleteKeys.includes(ev.key)) {
			ev.preventDefault();
			deleteSelected();
		} else if (escapeKeys.includes(ev.key)) {
			ev.preventDefault();
			select();
		}
	};

	return (
		<Styled.Root onKeyUp={onKeyUp}>
			<Styled.Canvas ref={onCanvasRef} />
		</Styled.Root>
	);
};
